import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {  Grid, Link, InputLabel, Select, MenuItem, FormControl, Grid2 } from "@mui/material";
import './StateModal.scss'
import { useEffect, useRef } from "react";


const states = [
  { name: "Alabama", abbreviation: "AL" },
  { name: "Alaska", abbreviation: "AK" },
  { name: "Arizona", abbreviation: "AZ" },
  { name: "Arkansas", abbreviation: "AR" },
  { name: "California", abbreviation: "CA" },
  { name: "Colorado", abbreviation: "CO" },
  { name: "Connecticut", abbreviation: "CT" },
  { name: "Delaware", abbreviation: "DE" },
  { name: "Florida", abbreviation: "FL" },
  { name: "Georgia", abbreviation: "GA" },
  { name: "Hawaii", abbreviation: "HI" },
  { name: "Idaho", abbreviation: "ID" },
  { name: "Illinois", abbreviation: "IL" },
  { name: "Indiana", abbreviation: "IN" },
  { name: "Iowa", abbreviation: "IA" },
  { name: "Kansas", abbreviation: "KS" },
  { name: "Kentucky", abbreviation: "KY" },
  { name: "Louisiana", abbreviation: "LA" },
  { name: "Maine", abbreviation: "ME" },
  { name: "Maryland", abbreviation: "MD" },
  { name: "Massachusetts", abbreviation: "MA" },
  { name: "Michigan", abbreviation: "MI" },
  { name: "Minnesota", abbreviation: "MN" },
  { name: "Mississippi", abbreviation: "MS" },
  { name: "Missouri", abbreviation: "MO" },
  { name: "Montana", abbreviation: "MT" },
  { name: "Nebraska", abbreviation: "NE" },
  { name: "Nevada", abbreviation: "NV" },
  { name: "New Hampshire", abbreviation: "NH" },
  { name: "New Jersey", abbreviation: "NJ" },
  { name: "New Mexico", abbreviation: "NM" },
  { name: "New York", abbreviation: "NY" },
  { name: "North Carolina", abbreviation: "NC" },
  { name: "North Dakota", abbreviation: "ND" },
  { name: "Ohio", abbreviation: "OH" },
  { name: "Oklahoma", abbreviation: "OK" },
  { name: "Oregon", abbreviation: "OR" },
  { name: "Pennsylvania", abbreviation: "PA" },
  { name: "Rhode Island", abbreviation: "RI" },
  { name: "South Carolina", abbreviation: "SC" },
  { name: "South Dakota", abbreviation: "SD" },
  { name: "Tennessee", abbreviation: "TN" },
  { name: "Texas", abbreviation: "TX" },
  { name: "Utah", abbreviation: "UT" },
  { name: "Vermont", abbreviation: "VT" },
  { name: "Virginia", abbreviation: "VA" },
  { name: "Washington", abbreviation: "WA" },
  { name: "West Virginia", abbreviation: "WV" },
  { name: "Wisconsin", abbreviation: "WI" },
  { name: "Wyoming", abbreviation: "WY" },
];










export default function UpsellModal({ open, onClose }) {
  const modalRef = useRef(null); // Create a reference for the modal content
  const [selectedState, setSelectedState] = React.useState("");


  const handleStateChange = (event) => {
    const selectedAbbreviation = event.target.value;
    const url = `https://www.hud.gov/sites/dfiles/PIH/documents/PHA_Contact_Report_${selectedAbbreviation}.pdf`;

    console.log(url); // Logs the generated URL

    // Open the URL in a new tab
    window.open(url, "_blank");
  };

  if (!open) return null; // Don't render the modal if not open

  if (!open) return null; // Render nothing if `open` is false


 




  return (
    <div className="modal-overlay">
      
      <div className="modal-content" style={{ maxWidth: '700px', overflow: 'auto' }}>
      <div style={{  marginRight: 0, display: 'flex' , justifyContent:'right', marginTop:'-13px' ,zIndex:1200, color:'black'}} >

<button onClick={onClose} >
X
</button>
</div>

<div className="modal-header" style={{ textAlign: 'center', padding: '20px' }}>
  <img
    src="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/8MxPEv2dda8JikaeCS0U/media/67928a62daf860f2a6df2e50.png" 
    alt="Welcome"
    style={{
      width: '100%',
      height: 'auto',
      marginTop: '-10px',
      marginLeft: '20px',
      borderRadius: '8px',
    }}
  />
  <h3 style={{ marginTop: '10px', fontSize: '30px', color: '#333', fontWeight: 'bold' }}>
    Inner Circle Feature
  </h3>
  <h3 style={{
    marginTop: '10px',
    fontSize: '16px',
    color: '#555',
    padding: '0 10px',
    lineHeight: '1.5',
    textAlign: 'center',
  }}>
    To access this tool, please sign up for our course below.
  </h3>
  <h3 style={{
    marginTop: '20px',
    fontSize: '16px',
    color: '#555',
    lineHeight: '1.5',
    textAlign: 'center',
  }}>
    In addition to accessing premium tools in this portal, you will also receive:
  </h3>
  <ul style={{
    listStyleType: 'disc',
    listStylePosition: 'inside', // Ensures the bullet points align with the text
    margin: '20px auto',
    padding: '0',
    maxWidth: '500px',
    textAlign: 'center',
    color: '#333',
    fontSize: '16px',
    lineHeight: '1.6',
  }}>
    <li style={{ display: 'list-item' }}>Hands-On Support - <strong>$15,000 Value</strong></li>
    <li style={{ display: 'list-item' }}>20+ Module Course - <strong>$6,500 Value</strong></li>
    <li style={{ display: 'list-item' }}>Document Vault - <strong>$3,500 Value</strong></li>
    <li style={{ display: 'list-item' }}>Bonus #1: LLC Strategy Session</li>
    <li style={{ display: 'list-item' }}>Bonus #2: Access to Our Lending Partner</li>
    <li style={{ display: 'list-item' }}>Bonus #3: Investor Community</li>
</ul>
</div>

        {/* <form>
          <select id="state" name="state" defaultValue="" 
          style={{color:'black',
          textAlign:'center',
          textAlignLast:'center',
          padding:'8px',
          width:'100%'
          
          
          }} onChange={handleStateChange}>
            <option value="" disabled>
              -- Select a State --
            </option>
            {states.map((state) => (
              <option key={state.abbreviation} value={state.abbreviation}>
                {state.name}
              </option>
            ))}
          </select>
        </form> */}
<button
  style={{
    backgroundColor: '#34b22c', // Clean blue color
    color: 'white',
    fontWeight:800, // White text
    border: 'none', // No border
    padding: '10px 20px', // Padding for better spacing
    fontSize: '16px', // Text size
    borderRadius: '5px', // Rounded corners
    cursor: 'pointer', // Pointer cursor on hover
    transition: 'background-color 0.3s, transform 0.2s', // Smooth transition for hover effects
    marginTop: '10px', // Keep margin from top
    width: '40%', // Make it full width (optional)
    height: '60px', // Make it full width (optional)
  }}
  onClick ={()=> window.open('https://elevatecoachingrei.com/join', "_blank")}   // Darker blue on hover
   // Revert back on hover out
>
  Join Inner Circle
</button>      </div>
    </div>
  );
};